import { CompanyMailingAddressFormValue } from '../../../../types'

export const mapCompanyMailingAddressForm = (formValue: CompanyMailingAddressFormValue) => ({
  ...formValue
})
